import "../styles.css";
import { useEffect, useState } from "react";
import {
  getCVPrestador,
  getPrestadores,
} from "../../../../services/SaudeBemEstar/SaudeEmocionalService";
import { Prestador } from "../../../../interfaces/entities/SaudeBemEstar/Agendamento/Prestador";
import DefaultButton from "../../../../components/Accessibility/DefaultButton";
import DefaultPagination from "../../../../components/Accessibility/DefaultPagination";
import { CircularProgress } from "@mui/material";
import PrestadorCard from "./PrestadorCard";
import pLimit from "p-limit";

const Step1EscolherPrestador: React.FC<{
  onAgendarClicked: (prestador: Prestador) => void;
}> = ({ onAgendarClicked }) => {
  const [prestadores, setPrestadores] = useState<Prestador[]>([]);
  const [pagePrestadores, setPagePrestadores] = useState<Prestador[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [page, setPage] = useState<number>(1);

  const pageSize = 5;
  const limit = pLimit(1);

  useEffect(() => {
    setLoading(true);
    getPrestadores()
      .then((response) => {
        setPrestadores(response);

        return loadPageData(response.slice(0, pageSize));
      })
      .catch(console.log)
      .finally(() => setLoading(false));
  }, []);

  const loadPageData = async (prestadores: Prestador[]) => {
    try {
      await Promise.all(
        prestadores.map((val) =>
          limit(async () => {
            val.curriculo = await getCVPrestador(val.idPessoa);
          })
        )
      );
      setPagePrestadores(prestadores);
      return true;
    } catch (error) {
      throw error;
    }
  };
  

  const handlePageChange = async (page: number) => {
    setPage(page);
    const start = (page - 1) * pageSize;
    const nextPageData = prestadores.slice(start, start + pageSize);
    setLoading(true);
    loadPageData(nextPageData).then((_) => setLoading(false));
  };

  return (
    <div className="width-100-pc flex-col gap-20">
      {!!loading && (
        <div className="width-100-pc flex-row justify-center">
          <CircularProgress />
        </div>
      )}

      {!loading && (
        <>
          {pagePrestadores.map((prestador) => (
            <PrestadorCard
              key={`${prestador.idPessoa}-${prestador.idInstal}`}
              prestador={prestador}
              button={
                <DefaultButton
                  onClick={() => onAgendarClicked(prestador)}
                  text="Agendar"
                />
              }
            />
          ))}
          <DefaultPagination
            currentPage={page}
            totalPages={Math.ceil(prestadores.length / pageSize)}
            handlePageChange={handlePageChange}
          />
        </>
      )}
    </div>
  );
};

export default Step1EscolherPrestador;
